module.exports = __webpack_public_path__ + "1f3ef1c76b243a9b443c1f81e71dfaa5.pdf";